import { useTranslation } from 'react-i18next'

import { Modal } from 'components-ref/molecules/modal/modal'
import {
    ViewLikesSearchUsers,
    ViewLikesUsersList
} from 'components-ref/molecules/viewlikes'
import { ViewLikesContextProvider } from 'context/ViewLikesContext/ViewLikesContext'

interface ViewLikesModalProps {
    onClose: () => void
    postId: string
    type?: 'post' | 'story'
}

export const ViewLikesModal = ({ postId, onClose, type = 'post' }: ViewLikesModalProps) => {
    const { t } = useTranslation()

    return (
        <ViewLikesContextProvider postId={postId}>
            <Modal
                title={t('Likes')}
                onClose={onClose}
                hasShadow={true}
                isLayerTransparent={false}
            >
                <>
                    <ViewLikesSearchUsers />
                    <ViewLikesUsersList type={type} />
                </>
            </Modal>
        </ViewLikesContextProvider>
    )
}